"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retailClientFactory = void 0;
require("reflect-metadata");
const container_1 = require("./container");
function retailClientFactory(apiUrl) {
    // create an IoC container
    const container = (0, container_1.createContainer)();
    // get an instance of RetailClient
    const retailClient = container.get("RetailClient");
    retailClient.httpConnection.url = apiUrl;
    retailClient.webSocketConnection.setUrl(apiUrl);
    retailClient.sync.setUrl(apiUrl);
    return retailClient;
}
exports.retailClientFactory = retailClientFactory;
//# sourceMappingURL=retailClientFactory.js.map